 import httpRequest from "../utils/axios.js";


 export function getWechatInfo(couponId = '') {
   var url = `api/coupon/transfer/wechat/auth/info?couponId=${couponId}`;
   return httpRequest.fetchPost(url);
 }